"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-modal", {
    staticClass: "modal-new-product",
    attrs: {
      active: true,
      width: 598,
      scroll: "keep",
      "can-cancel": ["escape"],
      "on-cancel": _vm.cancelModal
    }
  }, [_c("div", {
    staticClass: "card"
  }, [_c("div", {
    staticClass: "card-content"
  }, [_c("div", {
    staticClass: "media"
  }, [_c("div", {
    staticClass: "media-content"
  }, [_c("button", {
    staticClass: "btn-x-close",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.cancelModal
    }
  }, [_c("i", {
    staticClass: "icon-ic_close"
  })]), _vm._v(" "), _c("p", {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])])]), _vm._v(" "), _c("div", {
    staticClass: "content"
  }, [_c("form", [_c("b-field", {
    attrs: {
      label: "Nome do produto"
    }
  }, [_c("b-input", {
    attrs: {
      placeholder: "Nome",
      required: ""
    },
    model: {
      value: _vm.form.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nome", $$v);
      },
      expression: "form.nome"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Descrição (opcional)"
    }
  }, [_c("b-input", {
    attrs: {
      type: "textarea",
      placeholder: "Descreva de forma breve sobre o produto",
      rows: "3"
    },
    model: {
      value: _vm.form.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "descricao", $$v);
      },
      expression: "form.descricao"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Categoria"
    }
  }, [_c("b-select", {
    attrs: {
      placeholder: "Selecione uma categoria",
      required: "",
      expanded: ""
    },
    model: {
      value: _vm.form.categoria,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "categoria", $$v);
      },
      expression: "form.categoria"
    }
  }, [_c("option", {
    attrs: {
      value: ""
    }
  }, [_vm._v("\n                Selecionar\n              ")]), _vm._v(" "), _vm._l(_vm.categorias, function (categoria) {
    return _c("option", {
      key: categoria.value,
      domProps: {
        value: categoria.value
      }
    }, [_vm._v("\n                " + _vm._s(categoria.label) + "\n              ")]);
  })], 2)], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Fornecedor"
    }
  }, [_c("b-input", {
    attrs: {
      placeholder: "Fornecedor",
      required: ""
    },
    model: {
      value: _vm.form.fornecedor,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fornecedor", $$v);
      },
      expression: "form.fornecedor"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Medida"
    }
  }, [_c("b-select", {
    attrs: {
      placeholder: "Selecione uma medida",
      required: "",
      expanded: ""
    },
    model: {
      value: _vm.form.medida,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "medida", $$v);
      },
      expression: "form.medida"
    }
  }, [_c("option", {
    attrs: {
      value: ""
    }
  }, [_vm._v("\n                Selecionar\n              ")]), _vm._v(" "), _vm._l(_vm.medidas, function (medida) {
    return _c("option", {
      key: medida,
      domProps: {
        value: medida
      }
    }, [_vm._v("\n                " + _vm._s(medida) + "\n              ")]);
  })], 2)], 1), _vm._v(" "), _c("b-field", {
    staticClass: "row-save-form"
  }, [_c("b-button", {
    staticClass: "btn-save-form",
    on: {
      click: _vm.save
    }
  }, [_vm._v("\n              " + _vm._s(_vm.isEdit ? "Gravar" : "Criar") + "\n            ")])], 1)], 1)])])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;